export default class AzureFieldsExtractor {
  static extractFields(content) {
    if (typeof content === 'string') {
      content = JSON.parse(content);
    }

    content = content.analyzeResult;

    let fields = {};
    let words = {};
    for (let page of content.pages) {

      if (!words[page.pageNumber]) {
        words[page.pageNumber] = [];
      }

      for (let word of page.words) {
        words[page.pageNumber].push(word);
      }
    }

    for (let document of content.documents) {

      for (let [name, field] of Object.entries(document.fields)) {
        if (!field.content) {
          continue;
        }

        let pageindex = field.boundingRegions[0].pageNumber - 1;
        let value = '';

        switch (name) {
          case 'NumeroTVA':
          case 'FournisseurTVA':
            value = field.content.trim().toUpperCase().replace(/[^a-zA-Z0-9]/g, "");
            fields['fournisseurtva'] = {
              name: 'fournisseurtva',
              value: value,
              confidence: field.confidence,
              boundgregions: field.boundingRegions,
              pageindex: pageindex,
            };
            break;

          case 'FournisseurSiret':
            value = field.content.trim().replace(/[^0-9]/g, "");
            fields['fournisseursiret'] = {
              name: 'fournisseursiret',
              value: value,
              confidence: field.confidence,
              boundgregions: field.boundingRegions,
              pageindex: pageindex,
            };
            break;

          case 'EmailFournisseur':
          case 'FournisseurEmail':
            value = field.content.trim().toLowerCase().replace(/[^0-9a-zA-Z@\.\-_]/g, "");
            fields['fournisseuremail'] = {
              name: 'fournisseuremail',
              value: value,
              confidence: field.confidence,
              boundgregions: field.boundingRegions,
              pageindex: pageindex,
            };
            break;

          case 'SiteInternetFournisseur':
          case 'FournisseurSiteInternet':
            value = field.content.trim().toLowerCase().replace(/[^0-9a-zA-Z@\.\-_:/]/g, "");
            fields['fournisseursite'] = {
              name: 'fournisseursite',
              value: value,
              confidence: field.confidence,
              boundgregions: field.boundingRegions,
              pageindex: pageindex,
            };
            break;

          case 'Téléphone':
          case 'FournisseurTelephone':
            value = field.content.trim().replace(/[^\+0-9\(\)]/g, "");
            fields['fournisseurtelephone'] = {
              name: 'fournisseurtelephone',
              value: value,
              confidence: field.confidence,
              boundgregions: field.boundingRegions,
              pageindex: pageindex,
            };
            break;
          //
          // case 'IBAN':
          //   value = field.content.trim().toUpperCase().replace(/[^A-Z0-9]/g, "");
          //
          //   if (AzureFieldsExtractor.validateIBAN(value)) {
          //     fields['fournisseuriban'] = {
          //       name: 'fournisseuriban',
          //       value: value,
          //       confidence: field.confidence,
          //       boundgregions: field.boundingRegions,
          //       pageindex: pageindex,
          //     };
          //   }
          //
          //   break;
          //
          // case 'BIC':
          //   value = field.content.trim().toUpperCase().replace(/[^A-Z0-9]/g, "");
          //   // Note: BIC validation is not implemented here
          //   fields['fournisseurbic'] = {
          //     name: 'fournisseurbic',
          //     value: value,
          //     confidence: field.confidence,
          //     boundgregions: field.boundingRegions,
          //     pageindex: pageindex,
          //   };
          //   break;

          case 'TVA_Total1':
          case 'TVA_Total2':
          case 'TVA_Total3':
          case 'TotalTTC':
          case 'TotalTVA':
          case 'TotalTva':
          case 'TotalHT':
            let fieldname = name.toLowerCase();
            console.log(field, 'fieldname');

            fields[fieldname] = {
              name: fieldname,
              value: AzureFieldsExtractor._sanitizePrix(field.content),
              confidence: field.confidence,
              boundgregions: field.boundingRegions,
              pageindex: pageindex,
            };
            break;

          case 'FournisseurName':
            fields['fournisseurname'] = {
              name: 'fournisseurname',
              value: field.content.trim(),
              confidence: field.confidence,
              boundgregions: field.boundingRegions,
              pageindex: pageindex,
            };
            break;

          case 'FournisseurAdresse':
            fields['fournisseuradresse'] = {
              name: 'fournisseuradresse',
              value: field.content.trim(),
              confidence: field.confidence,
              boundgregions: field.boundingRegions,
              pageindex: pageindex,
            };
            break;

          case 'TVA_%1':
          case 'TVA_%2':
          case 'TVA_%3':
            fields[name.toLowerCase()] = {
              name: name.toLowerCase(),
              value: AzureFieldsExtractor._sanitizePourcent(field.content),
              confidence: field.confidence,
              boundgregions: field.boundingRegions,
              pageindex: pageindex,
            };
            break;

          case 'NumeroFacture':
            value = field.content.trim().toUpperCase().replace(/^N°/, "");
            fields['numerofacture'] = {
              name: 'numerofacture',
              value: value,
              confidence: field.confidence,
              boundgregions: field.boundingRegions,
              pageindex: pageindex,
            };
            break;

          case 'Date':
          case 'DateFacture':
            fields['date'] = {
              name: 'date',
              value: AzureFieldsExtractor._sanitizeDate(field.content),
              confidence: field.confidence,
              boundgregions: field.boundingRegions,
              pageindex: pageindex,
            };
            break;

          case 'DateEcheance':
            fields['dateecheancefacture'] = {
              name: 'dateecheancefacture',
              value: AzureFieldsExtractor._sanitizeDate(field.content),
              confidence: field.confidence,
              boundgregions: field.boundingRegions,
              pageindex: pageindex,
            };
            break;
          default:
            console.log(name, 'default');
            break;
        }
      }
    }

    if ( fields['totalht'] === undefined) {

      //si on a pas de total HT, on va essayer de calculer
      if (fields['totalttc'] && fields['totaltva']) {
        fields['totalht'] = {
          name: 'totalht',
          value: '' + (fields['totalttc'].value - fields['totaltva'].value),
          confidence: 0,
          boundgregions: [],
          pageindex: 0,
        };

      }else if ( fields['totalttc'] && fields['tva_total1']) {

        let totalhtcalculed = fields['totalttc'].value - fields['tva_total1'].value;
        if (fields['tva_total2']) {
          totalhtcalculed -=  fields['tva_total2'].value;
        }
        if (fields['tva_total3']) {
          totalhtcalculed -=  fields['tva_total3'].value;
        }

        fields['totalht'] = {
          name: 'totalht',
          value: ''+ Math.round(totalhtcalculed*100)/100,
          confidence: 0,
          boundgregions: [],
          pageindex: 0,
        };

      }else{

        fields['totalht'] = {
          name: 'totalht',
          value: '',
          confidence: 0,
          boundgregions: [],
          pageindex: 0,
        };
      }
    }

    return {fields, words};
  }

  static _sanitizePrix(number_string) {
    number_string = number_string.replace(/[^0-9,\.\-]/g, '');
    number_string = number_string.replace(',', '.');

    let theCount = (number_string.match(/\./g) || []).length;

    if (theCount < 2) {
      return number_string;
    }

    return number_string.replace(/\.(?=.*\.)/g, '');
  }

  static _sanitizePourcent(number_string) {
    number_string = number_string.replace(/[^0-9%,\.\-]/g, '');

    // convert 17%05 to 17.05
    if (number_string.match(/%/)) {
      number_string = number_string.replace(/%/g, '.');
    }

    //supprime le . à la fin
    if (number_string.match(/\.$/)) {
      number_string = number_string.replace(/\.$/, '');
    }

    return number_string.replace(',', '.');
  }

  static _sanitizeDate(date_string) {

    date_string = date_string.toLowerCase().replace(/\./g, '/').trim();
    date_string = date_string.replace(/lundi\s|mardi\s|mercredi\s|jeudi\s|vendredi\s|samedi\s|dimanche\s|lun\s|mar\s|mer\s|jeu\s|ven\s|sam\s|dim\s/g, '').trim();

    if (/^[0-9]+\s[a-zA-Z]+/.test(date_string)) {
      const moisfr = ['janvier', 'janv', 'février', 'fevrier', 'fev', 'mars', 'mar', 'avr', 'avril', 'mai', 'juin', 'juillet', 'juil', 'août', 'aout', 'aou','sep', 'septembre', 'oct', 'octobre', 'novembre','nov', 'décembre', 'decembre', 'dec'];
      const moisen = ['january', 'january', 'february', 'february', 'february', 'march','march', 'april', 'april', 'may', 'june', 'july', 'july', 'august', 'august', 'august', 'september', 'september', 'october','october', 'november', 'november', 'december', 'december', 'december'];

      for (let i = 0; i < moisfr.length; i++) {
        date_string = date_string.replace(moisfr[i], moisen[i]);
      }

      // ajout 12h pour que la date soit correcte
      date_string += ' 12:00:00';
      
      return new Date(date_string).toISOString().split('T')[0];
    }

    let matches = date_string.match(/^([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{2}|[0-9]{4})$/);
    if (matches) {
      if (matches[3].length === 2) {
        matches[3] = '20' + matches[3];
      }
      return `${matches[3]}-${matches[2].padStart(2, '0')}-${matches[1].padStart(2, '0')}`;
    }

    date_string = date_string.replace(/[^0-9\-]/g, '-');

    let parts = date_string.split('-');
    if (parts.length !== 3) {
      return null;
    }

    let [y, m, d] = parts;
    if (y.length === 4) {
      return date_string;
    } else {
      return `${d}-${m}-${y}`;
    }
  }

  //
  // static validateIBAN(iban) {
  //   // Remove spaces and convert to uppercase
  //   iban = iban.replace(/\s/g, '').toUpperCase();
  //
  //   // Basic format check
  //   if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/.test(iban)) {
  //     return false;
  //   }
  //
  //   // Move the first four characters to the end
  //   iban = iban.slice(4) + iban.slice(0, 4);
  //
  //   // Replace each letter with two digits (A=10, B=11, ..., Z=35)
  //   iban = iban.split('').map(char => {
  //     const code = char.charCodeAt(0);
  //     return (code >= 65 && code <= 90) ? (code - 55).toString() : char;
  //   }).join('');
  //
  //   // Perform the mod-97 operation
  //   let remainder = iban;
  //   while (remainder.length > 2) {
  //     const block = remainder.slice(0, 9);
  //     remainder = (parseInt(block, 10) % 97).toString() + remainder.slice(9);
  //   }
  //
  //   // If the remainder is 1, the IBAN is valid
  //   return parseInt(remainder, 10) === 1;
  // }
}